"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ({ projectId }) => {
    return {
        schemaType: "object",
        properties: [
            {
                title: "作成日時",
                propertyName: "createdAt",
                schema: {
                    schemaType: "datetime",
                },
            },
            {
                title: "翻訳ファイル名",
                propertyName: "segmentName",
                schema: {
                    schemaType: "text",
                },
            },
            {
                title: "未解決コメント数",
                propertyName: "unresolvedComments",
                schema: {
                    schemaType: "text",
                },
            },
            {
                title: "最終更新日",
                propertyName: "updatedAt",
                schema: {
                    schemaType: "datetime",
                },
            },
        ],
    };
};
